<template>
  <header class="app__header min-h-[56px]" v-if="FMStore.currentStep !== 'Welcome' && FMStore.currentStep !== 'Done' ">
    <button class="w-[24px] h-[24px] flex items-center justify-center" @click="goBack">
      <Icon icon="back" size="20"/>
    </button>
    <div class="progress flex items-center gap-0.5" v-if="FMStore.currentStep !== 'Confirm' && !FMStore.isReschedule && FMStore.stepNumber && FMStore.stepNumber >= 1 && +FMStore.stepNumber <= 3">
       {{FMStore.stepNumber}} of 3
    </div>
    <button class="w-[24px] h-[24px] flex items-center justify-center" @click="exit">
      <Icon icon="exit" size="20"/>
    </button>
  </header>
</template>

<script setup lang="ts">
import Icon from "~/components/ui/Icon.vue";
import {useFMStore} from "@/store/FMStore";
const FMStore = useFMStore();
const goBack = () => {
  FMStore.goBack()
}
const exit = () => {
  FMStore.resetFlow()
}
const route = useRoute();
const shouldShowHeader = computed(() => {
  return route.meta.showHeader !== false;
});
</script>

<style lang="scss" scoped>
.app__header {
  height: 56px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 16px;
  background: #FFFFFF;
  box-shadow: 0px 0.5px 0px rgba(0, 0, 0, 0.3);

  .progress {
    font-weight: 600;
    font-size: 16px;
    line-height: 125%;
    color: var(--grey-800);
  }
}
</style>
